$(function () {

    "use strict";

    function PageBannersSlider(options) {
        var defaultOptions = {
            speed: 4000,
            interval: 4000,
            autoplay: true,
            onBeforeChange: function () { },
            onAfterChange: function () { }
        };

        this.options = $.extend(defaultOptions, options);

        this.$slider = options.$slider;
        this.$video = options.$video;
        this.$fullVideo = options.$fullVideo;
        this.$navArrows = options.$navArrows;
        this.$navDots = options.$navDots;

        this.initBehaviour();
    }

    PageBannersSlider.prototype = {
        initEvents: function () {
            var me = this;

            if (me.$video) {
                me.$video.each(function () {
                    $(this).get(0).play();
                });
            }

            if (me.$fullVideo) {
                $('.js-close-video').on('click', function (e) {
                    $('.m-full-screen-video').removeClass('is-active');
                    $('#container').removeClass('is-active');

                    me.$fullVideo.removeClass('is-active');
                    me.$video.each(function () {
                        $(this).get(0).play();
                    });

                    me.$fullVideo.each(function () {
                        $(this).get(0).pause();
                    });
                });

                $('.js-play-video').on('click', function (e) {
                    var videoPopup = $('.m-full-screen-video');
                    var slideId = $(this).data('slideId');
                    var video = videoPopup.find('video[data-slide-id=' + slideId + ']');
                    video.get(0).play();
                    video.addClass('is-active');
                    videoPopup.addClass('is-active');
                    $('#container').addClass('is-active');

                    me.$video.each(function () {
                        $(this).get(0).pause();
                    });
                });
            }

            // add navigation events
            me.$navArrows.children(':last').on('click', function () {
                me.slitslider.next();
                return false;
            });

            me.$navArrows.children(':first').on('click', function () {
                me.slitslider.previous();
                return false;
            });

            me.$navDots.each(function (i) {
                $(this).on('click', function (e) {
                    var $dot = $(this);

                    if (!me.slitslider.isActive()) {
                        me.$navDots.removeClass('nav-dot-current');
                        $dot.addClass('nav-dot-current');
                    }

                    me.slitslider.jump(i + 1);

                    return false;
                });
            });
        },

        initBehaviour: function () {
            var me = this;

            this.slitslider = this.$slider.slitslider({
                autoplay: me.options.autoplay,
                speed: me.options.speed,
                interval: me.options.interval,
                onBeforeChange: function (slide, pos) {
                    me.options.onBeforeChange(slide, pos);
                },
                onAfterChange: function () {
                    me.options.onAfterChange(me.$video);
                }
            });

            me.initEvents();
        }
    };
    
    var slider = new PageBannersSlider({
        $slider: ($('#mainPageSliderWithVideo').length) ? $('#mainPageSliderWithVideo') : $('#mainPageSlider'),
        $video: $('.js-slider-video'),
        $fullVideo: $('.js-full-screen-video-item'),
        $navArrows: $('#nav-arrows'),
        $navDots: $('#nav-dots > span'),

        speed: 800,
        interval: getInterval(),
        autoplay: true,
        onBeforeChange: function (slide, pos) {
            this.$navDots.removeClass('nav-dot-current');
            this.$navDots.eq(pos).addClass('nav-dot-current');
        },
        onAfterChange: function ($video) {
            if ($video) {
                this.$video.each(function () {
                    $(this).get(0).play();
                });
            }
        }
    });

    var justPrintHomeSlider = new PageBannersSlider({
        $slider: $('#justPrintHomeSlider'),
        $video: $('.js-slider-video'),
        $fullVideo: $('.js-full-screen-video-item'),
        $navArrows: $('#justPrintHomeSliderNavArrows'),
        $navDots: $('#justPrintHomeSliderNavDots > span'),

        speed: 800,
        interval: getInterval(),
        autoplay: true,
        onBeforeChange: function (slide, pos) {
            this.$navDots.removeClass('nav-dot-current');
            this.$navDots.eq(pos).addClass('nav-dot-current');
        },
        onAfterChange: function ($video) {
            if ($video) {
                this.$video.each(function () {
                    $(this).get(0).play();
                });
            }
        }
    });

    function getInterval() {
        var videoElemennt = $('.js-slider-video');
        if (videoElemennt.length === 0) {
            return 10000;
        } else {
            var duration = videoElemennt[0].duration;
            return duration ? Math.max(duration, 10) * 1000 : 10000;
        }
    }

});